import { forwardRef, PropsWithChildren, useEffect, useState } from "react";
import { Button, ForwardRefComponent, MenuItem, ToolbarButton, ToolbarDivider, ToolbarGroup, makeStyles, shorthands, tokens, useIsOverflowItemVisible } from "@fluentui/react-components";
import { IReportRequestsButtonProps } from "./report-requests-button.props";
import {
    HistoryRegular
} from "@fluentui/react-icons";
import { useLocation, useNavigate } from "react-router-dom";
import { ILocaleStrings } from "loc/locale.interfaces";
import { useL10n } from "context/l10n-context";
import { usePPA } from "context/ppa-context";
import { PPAPermissions } from "lib/permissions";
import Trimmed from "components/common/trimmed/trimmed";

const layoutStyles = makeStyles({

});

export const ReportRequestsButton: ForwardRefComponent<IReportRequestsButtonProps> = forwardRef((props, ref) => {
    const styles = layoutStyles();
    const { t } = useL10n<ILocaleStrings>();
    const { hasPermission } = usePPA();
    const navigate = useNavigate();
    const location = useLocation();

    const [search, setSearch] = useState<string>();

    useEffect(() => {
        // TODO: This into a utility to split
        const attributes = new Array();

        // Split on forward slash and remove any empty items.
        const parts = location.pathname.split('/').filter(p => p);
        if (parts.length >= 2)
            attributes.push(`category=${parts[1]}`);
        if (parts.length >= 3)
            attributes.push(`report=${parts[2]}`);
        //
        const search = attributes.join('&');
        //
        setSearch(search);

        //console.log(parts);
    }, [location.pathname]);

    const onClick = () => {
        navigate(`/report-requests?${search}`)
    }

    if (!hasPermission([PPAPermissions.ViewAllReportRequests, PPAPermissions.ViewMyReportRequests]))
        return (<></>);

    if (props.isOverflowingMenu)
        return (
            <MenuItem
                icon={<HistoryRegular />}
                disabled={false}
                onClick={onClick}>{t('ppaRequests')}</MenuItem>
        );

    return (
        <Button
            ref={ref}
            icon={<HistoryRegular />}
            disabled={false}
            appearance="subtle"
            onClick={onClick} >{t('ppaRequests')}</Button>
    );
});